<template>
    <!-- Only show user medicines if logged in -->
    <div v-if="currentCustomer" class="mid-container">
        <div class="product-slider-header"><h3>MI BOTIQUÍN</h3></div>
        <div v-if="bigHopper">
        <hooper class="product-slider" :itemsToShow="3" ref="hooper">
            <slide v-for="(data,index) in userFavorites" :key="index">
                <div class="my-medicine">
                    <div class="box-product columns space-around product-hover-card center pointer"  style="width:auto;height:auto" @click="GetProductBySlug(data.product.slug)" >
                        <img onerror="this.src='https://images.gofarma.com.mx/fallback.jpeg';" :alt="data.product.name" :src="'https://images.gofarma.com.mx/'+data.product.sku+'-1.jpeg'" />
                            
                        <div class="parent-container">
                            <div class="container">
                                <p class="product-name">{{data.product.name}}</p>
                            </div>
                        </div>

                        <div class="product-info">
                            <div>
                                <span class="cost">${{data.product.basePrice | numeral('0.00')}}</span>
                            </div>
                        </div>
                        <!--<span v-if="hoverIndex===index" class="gofarma-bg-aqua" >Agregar al Carrito</span>-->
                    </div>
                </div>
            </slide>
            <hooper-navigation slot="hooper-addons"></hooper-navigation>
        </hooper>
        </div>
        <hooper v-if="!bigHopper" class="product-slider" :itemsToShow="1">
            <slide v-for="(data,index) in userFavorites" :key="index">
                <div class="my-medicine">
                    <div class="box-product columns space-around product-hover-card center pointer"  style="width:auto;height:auto"  @click="GetProductBySlug(data.product.slug)">
                        <img onerror="this.src='https://images.gofarma.com.mx/fallback.jpeg';" :alt="data.product.name" :src="'https://images.gofarma.com.mx/'+data.product.sku+'-1.jpeg'" />
                            
                        <div class="parent-container">
                            <div class="container">
                                <p class="product-name">{{data.product.name}}</p>
                            </div>
                        </div>

                            <div class="product-info">
                            <div>
                                <span class="cost">${{data.product.basePrice | numeral('0.00')}}</span>
                            </div>
                        </div>
                        <!--<span v-if="hoverIndex===index" class="gofarma-bg-aqua" >Agregar al Carrito</span>-->
                    </div>
                </div>
            </slide>
            <hooper-navigation slot="hooper-addons"></hooper-navigation>
        </hooper>
    </div>
</template>

<script>
import {Hooper, Slide, Navigation as HooperNavigation} from 'hooper';
import 'hooper/dist/hooper.css';
import { mapState,mapActions } from 'vuex'
export default {
    components: {
        Hooper,
        Slide,
        HooperNavigation
    },
    data(){
        return{
            bigHopper:true
        }
    },
    mounted(){
        this.CheckWidth()
    },
    created() {
        window.addEventListener("resize", this.CheckWidth);
    },
    destroyed() {
        window.removeEventListener("resize", this.CheckWidth);
    },
    methods:{
        CheckWidth(e) {
            if(window.innerWidth <= 962){
                this.bigHopper=false
            }else{
                this.bigHopper=true
            }
        },
        ...mapActions(['ProductDetail','GetProductBySlug'])
    },
    computed:{
        ...mapState(['currentCustomer','userFavorites'])
    }
  
}
</script>

<style scoped>
.hooper-list{
    height: auto;
}
</style>

